import { useState, useEffect } from "react";
import { buscarPeriodosService } from "../services/buscarPeriodosService";
// --------------------- Import Services ---------------------

export const useBuscarPeriodos = (cotaId: number | null | undefined) => {
  const [periodos, setPeriodos] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      setIsLoading(true);
      const data = await buscarPeriodosService(cotaId);

      setPeriodos(data);
      setIsLoading(false);
    };

    fetch();
  }, [cotaId]);
  // Retorna as variáveis de estado para o componente que utiliza este hook
  return { periodos, isLoading };
};
